import YouAndMeTextProduct from './components/YouAndMeTextProduct'
import YouAndMeTextLoader from './components/YouAndMeTextLoader'

export default {
    install(Vue, option) {
        Vue.component('YouAndMeTextProduct', YouAndMeTextProduct);
        Vue.component('YouAndMeTextLoader', YouAndMeTextLoader);
    }
};
